module.exports = __webpack_public_path__ + "img/ArcTitan.f663203b.svg";